<div class="round-corner-bordered-data-card">
  <span class="tw-h-10 tw-text-3xl tw-font-semibold tw-leading-[125%] tw-text-dt-text-headings">
    {{ earningAmount | currency: currency }}
  </span>

  <span
    class="tw-absolute tw-right-5 tw-mb-1.5 tw-text-base tw-font-medium tw-text-dt-text-secondary"
  >
    {{ currency }}
  </span>
</div>
